import request from '@/utils/request'
// 城市列表
export function cityListTree() {
  return request({
    url: '/biz/admin/area/city/tree',
    method: 'get'
  })
}

export function listArea(query) {
  return request({
    url: '/biz/admin/area/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询省市区地区信息分页
export function pageArea(query) {
  return request({
    url: '/biz/admin/area/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function updateHot(query) {
  return request({
    url: '/biz/admin/area/hot',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 城市列表
export function areaListTree() {
  return request({
    url: '/biz/admin/area/tree',
    method: 'get'
  })
}

export function areaListLakala() {
  return request({
    url: '/biz/admin/area/lakala',
    method: 'get'
  })
}

// 导入待发货
export function importLakala(data) {
  return request({
    url: '/biz/admin/area/lakala/import',
    method: 'post',
    data: data
  })
}

// 城市列表
export function commonRemoteCity() {
  return request({
    url: '/biz/admin/area/common/remote',
    method: 'get'
  })
}

// 城市列表
export function commonRemoteAll() {
  return request({
    url: '/biz/admin/area/common/all',
    method: 'get'
  })
}


// 物流运费模板列表 2022-03-29
export function shippingTemplatesList(data) {
  return request({
    url: '/biz/admin/shipping/template/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: data
  })
}

// 物流运费模板详情
export function templateDetailApi(data) {
  return request({
    url: '/biz/admin/shipping/template/detail',
    method: 'get',
    params: data
  })
}

// 物流运费模板新增 2022-03-29
export function shippingSave(data) {
  return request({
    url: '/biz/admin/shipping/template/add',
    method: 'post',
    data: data
  })
}

// 物流运费模板更新
export function shippingUpdate(data) {
  return request({
    url: '/biz/admin/shipping/template/edit',
    method: 'post',
    data: data
  })
}

// 物流运费模板删除
export function shippingDetete(data) {
  return request({
    url: '/biz/admin/shipping/template/delete',
    method: 'post',
    data: data
  })
}
